window.XBReviewsUtils = {
  escape(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  },

  stars(rating) {
    const value = Math.round(
      Math.max(0, Math.min(5, Number(rating) || 0))
    );

    return (
      "★★★★★".slice(0, value) +
      "☆☆☆☆☆".slice(0, 5 - value)
    );
  },

  initials(name) {
    const parts = String(name ?? "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (!parts.length) {
      return "?";
    }

    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    return (
      parts[0][0] +
      parts[parts.length - 1][0]
    ).toUpperCase();
  },

  formatDate(date, locale) {
    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "";
    }

    const safeLocale = locale === "ar" ? "ar" : "en";

    return parsedDate.toLocaleDateString(safeLocale, {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  }
};